module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-regular-straight-AFQI6GFM.woff?d717599abe25e96c739387b79c3d82f3";